/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-ip-reputation-type-mapping-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleCreate = `${prefix}.modalTitleCreate`;
export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const typeMappingsLabel = `${prefix}.typeMappingsLabel`;
export const addButtonLabel = `${prefix}.addButtonLabel`;
export const botClientClassLabel = `${prefix}.botClientClassLabel`;
export const botClientTypeLabel = `${prefix}.botClientTypeLabel`;
export const identifierLabel = `${prefix}.identifierLabel`;

export const ENGLISH = {
    [modalTitleCreate]: 'Create IP Reputation Mapping',
    [modalTitleEdit]: 'Edit IP Reputation Mapping',
    [typeMappingsLabel]: 'Type Mappings ({0})',
    [addButtonLabel]: 'Add',
    [botClientClassLabel]: 'Bot Client Class',
    [botClientTypeLabel]: 'Bot Client Type',
    [identifierLabel]: 'Identifier',
};
